import React, { useEffect, useState } from "react";
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../../environment/BackendService";
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { LEGACY_SCREEN_VIEW, ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import { downloadCSV, navigateToPresto } from "../../../../common_nextgen/utils/UtilFunctions";

const useFormularyStatusList = (
  onSelect,
  hideModal,
  initialSelectParams,
  initialSelectMode,
  initialLookupType,
  selectParamsData = {
    searchCriteria: "",
  }
) => {
  const { axios_helper_no_header } = useAxios();
  const toast = useToast();
  const location = useLocation();
  const [data, setData] = useState([]); /* Formulary Status Data */
  const [paramsData, setParamsData] = useState(selectParamsData); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [previousScreen, setPreviousScreen] = useState(location.pathname);
  const [hideFlag, setHideFlag] = useState(false);

  const {
    ADD_FORMULARY_STATUS_LIST,
    DISPLAY_FORMULARY_STATUS_LIST,
    STATUS_FORMULARY_STATUS_LIST,
  } = ROUTE_PATHS;

  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const [selectMode, setSelectMode] = useState(initialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);

  const screen_title = "Formulary Status List";
  const screenNumber = "RCFS1005";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "FS1 List",
      name: "searchCriteria",
      label: "List",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };
  const handleBack = () => {
    if(lookupType === "external"){
      const message = {type:"hideModal"};
      window.parent.postMessage(message, "*");
    }
    else{
      hideModal();
    }
  };
  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  // const leftButtons = [
  //   {
  //     button_label: "Back",
  //     button_handeler: () => {
  //       navigateToPage(DISPLAY_FORMULARY_STATUS_LIST);
  //     },
  //     button_key: "F12",
  //   },
  // ];
  const ctaButtons = [
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const [dialogVisible, setDialogVisible] = useState(
    location.state !== null &&
      Array.isArray(location.state) &&
      location.state.length > 0 &&
      location.state[0] &&
      location.state[0].hasOwnProperty("modal")
      ? location.state[0]["modal"]
      : false
  );
  /* Gear Icon Menu option CTAs */
  const menuOptions = selectMode
    ? [
        {
          label: "Select",
          icon: <span className="material-icons">add</span>,
          command: () => {
            const paramDataMap = new Map();
            selectParams.forEach((key) => {
              if (rowData.hasOwnProperty(key["target"])) {
                paramDataMap.set(key["source"], rowData[key["target"]]);
              }
            });
            const paramData = Object.fromEntries(paramDataMap);
            if (lookupType !== "external") {
              onSelect(paramData);
            } else {
              const message = {
                type: "responseData",
                data: paramData,
              };
              window.parent.postMessage(message, "*");
            }
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            console.log(rowData);
            navigateToPresto("RCFS1005", {
              fs1List: rowData.list,
              fs1Description: rowData.description,
            });
          },
        },
        {
          label: "Status",
          icon: <span className="material-icons">info</span>,
          command: () => {
            console.log(rowData);
            navigateToPresto(LEGACY_SCREEN_VIEW.RCFS2001I, {
              fs1List: rowData.list,
              fs1Description: rowData.description,
            });
          },
        },
      ]
    : [
        {
          label: "Select",
          icon: <span className="material-icons">select_all</span>,
          command: () => {
            navigateToPage(ADD_FORMULARY_STATUS_LIST, {
              selectedPriceSchedules: selectedRows.length
                ? selectedRows
                : [rowData.z2ryhj],
              previousScreen: location.pathname,
            });
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            navigateToPage(DISPLAY_FORMULARY_STATUS_LIST, {
              selectedPriceSchedules: selectedRows.length
                ? selectedRows
                : [rowData.z2ryhj],
              previousScreen: location.pathname,
            });
          },
        },
        {
          label: "Status",
          icon: <span className="material-icons">info</span>,
          command: () => {
            navigateToPage(STATUS_FORMULARY_STATUS_LIST, {
              selectedPriceSchedules: selectedRows.length
                ? selectedRows
                : [rowData.z2ryhj],
              previousScreen: location.pathname,
            });
          },
        },
      ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "List",
      field: "list",
    },
    {
      header: "Description",
      field: "description",
    },
  ];

  /* Param Key which used as bridge between various operations on tabular data */
  const parmKey = "list";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/formularyPatientList`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, selectedOption]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteFormularyStatus = () => {
    if (selectedOption === "yes") {
      const params = { z2ryhj: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/formularystatuslist", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/formularyPatientList/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;
    if (type === "initData") {
      console.log("iframe load", type, data);
      const { selectMode, data: paramData } = data; 
      setLookupType("external");
      setSelectParams(paramData.params);
      setParamsData(paramData.paramsData);      
      setSelectMode(selectMode);
    }    
  };
  
    useEffect(() => {
      window.addEventListener("message", handleMessage);
      return () => window.removeEventListener("message", handleMessage);
    }, []);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    leftButtons,
    ctaButtons,
    data,
    dialogVisible,
    setDialogVisible,
    parmKey,
    menuOptions,
    leftButtons,
    selectMode,
    columnDef,
    rowData,
    setRowData,
    selectedRows,
    setSelectedRows,
    previousScreen,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteFormularyStatus,
    setSelectedOption,
  };
};

export default useFormularyStatusList;
